// removed by extract-text-webpack-plugin
module.exports = {"theme__nav":"src-components-ThemeNavFooter----ThemeNavFooter-module---theme__nav---2-0c-","theme__nav__link":"src-components-ThemeNavFooter----ThemeNavFooter-module---theme__nav__link---1BHwh","theme__nav__link__active":"src-components-ThemeNavFooter----ThemeNavFooter-module---theme__nav__link__active---3Cwkv","conclusion__link":"src-components-ThemeNavFooter----ThemeNavFooter-module---conclusion__link---2I3dm","conclusion__link__active":"src-components-ThemeNavFooter----ThemeNavFooter-module---conclusion__link__active---3v9_s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThemeNavFooter/ThemeNavFooter.module.scss
// module id = 869
// module chunks = 168707334958949